// extracted by mini-css-extract-plugin
export default {"address":"style_address__U2AOe","address1":"style_address1__1gb2-","address2":"style_address2__PV7z5","city":"style_city__+7NSY","zip":"style_zip__F54jJ"};